import type { ModuleMigrationDef } from "@kubdee/sdk";

export const migration: ModuleMigrationDef = {
  key: "002_add_registration_date",
  version: "1.1.0",
  sql: `
ALTER TABLE \`fleet_vehicles\` ADD COLUMN \`registration_date\` text;
ALTER TABLE \`fleet_vehicles\` DROP COLUMN \`year\`;
`,
};
